import { useRef } from "react";

interface Props {
  showLootBox: () => void;
  resetTimeout?: number;
}

export const HiddenButton: React.FC<Props> = ({
  showLootBox,
  resetTimeout = 1500,
}) => {
  const timeoutId = useRef<NodeJS.Timeout>();
  const clickCount = useRef(0);

  const startResetClicksCountTimer = () => {
    timeoutId.current = setTimeout(() => {
      clickCount.current = 0;
    }, resetTimeout);
  };

  const handleHiddenClick = () => {
    if (clickCount.current === 0) {
      startResetClicksCountTimer();
    }

    clickCount.current++;

    if (clickCount.current === 3) {
      clearTimeout(timeoutId.current!);
      showLootBox();
    }
  };

  return (
    <div
      className="dqm-tcui-hidden-button"
      onClick={handleHiddenClick}
      data-testid="hidden-button"
    ></div>
  );
};
